<template>
  <div class="container py-5 position-relative">
    <div class="row row-grid justify-content-around align-items-center">
      <div class="col-lg-7">
        <slot name="pr-1"></slot>
      </div>
      <div class="col-lg-5 ">
        <slot name="pl-1"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "G1",
};
</script>

<style scoped>



</style>